import Cookies from 'js-cookie';
import PropTypes from 'prop-types';
import React from 'react';

import { MARKETO } from '../constants';

const qsStore = '_fs_qs';

const setUTMCookie = () => {
  if (typeof window === 'undefined') {
    return;
  }
  if (Cookies.get(MARKETO.UTM_COOKIE)) return;
  // Store utm data for later submission (assumes they will be utm_[something]:
  /* eslint-disable-next-line no-undef */
  let urlParams = new URLSearchParams(window.location.search);

  let cookieVal = '';
  for (let key of urlParams.keys()) {
    if (key.indexOf('utm_') === 0 || key.indexOf('refer') === 0) {
      let utmKey = key;
      if (key.indexOf('utm_') === 0) {
        let marketoMod = '_2';
        let addMod = key.slice(-2) !== '_2';
        utmKey = `${utmKey}${addMod ? marketoMod : ''}`;
      }
      cookieVal += `${utmKey}=${urlParams.get(key)}|`;
    }
  }
  if (cookieVal) {
    Cookies.set(MARKETO.UTM_COOKIE, cookieVal.slice(0, -1), { expires: null });
  }
};

const setReferrer = () => {
  if (typeof window === 'undefined') {
    return;
  }

  // if (!checkConsent()) return;
  /*Store utm data for later submission*/
  /* eslint-disable-next-line no-undef */
  var urlParams = new URLSearchParams(window.location.search);

  // Only set cookies for whitelisted parameter names
  const allowedPrefixes = ['utm_', 'refer'];
  for (let key of urlParams.keys()) {
    if (allowedPrefixes.some((prefix) => key.startsWith(prefix))) {
      Cookies.set(key, urlParams.get(key), { expires: null });
    }
  }

  const referrer = Cookies.get('_fs_oreferrer');
  if (!referrer && window.Osano?.cm?.getConsent()?.ANALYTICS === 'ACCEPT') {
    Cookies.set('_fs_oreferrer', window.document.referrer, { expires: null });
  }
};

function cleanQueryStringKeepLast(rawQueryString) {
  const params = new URLSearchParams(rawQueryString);
  const result = new URLSearchParams();

  for (const [key, value] of params.entries()) {
    result.set(key, value);
  }

  return `?${result.toString()}`;
}

const applyQueryString = () => {
  if (typeof window === 'undefined') return;
  const qs = window?.location?.search;
  const url = new URL(window.location.href);
  const currentParams = new URLSearchParams(url.search);

  const storedQS = sessionStorage.getItem(qsStore);

  let cleanedQS = storedQS;
  if (storedQS) {
    cleanedQS = cleanQueryStringKeepLast(storedQS);
  }
  const storedParams = cleanedQS ? new URLSearchParams(cleanedQS) : null;

  const hasUtms = [...currentParams.keys()].some((key) => key.startsWith('utm_') || key === 'fs_product');

  const storedUtms =
    storedParams && [...storedParams.keys()].some((key) => key.startsWith('utm_') || key === 'fs_product');

  let consented = true;
  if (window.Osano && window.Osano?.cm?.getConsent()?.MARKETING !== 'ACCEPT') {
    consented = false;
  }

  if (consented && hasUtms) {
    window.sessionStorage?.setItem(qsStore, qs);
  }

  if (!qs && storedUtms && storedParams) {
    // Merge stored params with current URL (which has no query string at this point)
    const mergedParams = new URLSearchParams();

    for (const [key, value] of storedParams.entries()) {
      if (!mergedParams.has(key)) {
        mergedParams.set(key, value);
      }
    }

    // Build new URL with merged query string
    const newUrl = `${window.location.origin}${window.location.pathname}?${mergedParams.toString()}`;

    window.history.replaceState({}, '', newUrl);
  }
};

const storeABTastyVariations = () => {
  if (typeof window === 'undefined' || !window.ABTasty) return;
  const abData = window.ABTasty.getTestsOnPage();
  if (!abData) return;
  const keys = Object.keys(abData);
  if (keys?.length === 0) return;
  const lastKey = keys[keys.length - 1];
  sessionStorage.setItem('ab.c.id', lastKey?.toString());
  sessionStorage.setItem('ab.c.name', abData[lastKey]?.name);
  sessionStorage.setItem('ab.v.id', abData[lastKey]?.variationID?.toString());
  sessionStorage.setItem('ab.v.name', abData[lastKey]?.variationName);
};

/**
 * Wrapper to collect incoming marketing data
 *
 * @param props
 * @returns {*}
 * @constructor
 */
const MarketingStore = (props) => {
  applyQueryString();
  setReferrer();
  setUTMCookie();
  storeABTastyVariations();
  return <>{props.children}</>;
};

MarketingStore.propTypes = {
  children: PropTypes.any,
};

export default MarketingStore;
